// 应用入口统一使用绝对路径，避免挂到当前页面目录下，并保留查询参数。
export function normalizeRoutePath(path) {
  if (typeof path !== 'string' || !path) return ''
  const suffixIndex = path.search(/[?#]/)
  const pathname = suffixIndex > -1 ? path.slice(0, suffixIndex) : path
  const suffix = suffixIndex > -1 ? path.slice(suffixIndex) : ''
  const normalizedPath = `/${pathname}`.replace(/\/+/g, '/').replace(/\/$/, '') || '/'
  return normalizedPath + suffix
}

function resolveChildPath(parentPath, childPath) {
  if (typeof childPath !== 'string' || !childPath) return ''
  if (childPath.startsWith('/')) return normalizeRoutePath(childPath)
  const normalizedParentPath = normalizeRoutePath(parentPath).replace(/[?#].*$/, '')
  return normalizeRoutePath(`${normalizedParentPath}/${childPath}`)
}

function isSameRoutePath(sourcePath, targetPath) {
  const normalizedSourcePath = normalizeRoutePath(sourcePath).replace(/[?#].*$/, '')
  const normalizedTargetPath = normalizeRoutePath(targetPath).replace(/[?#].*$/, '')
  return !!normalizedSourcePath && normalizedSourcePath === normalizedTargetPath
}

export function getSafeRedirect(sourcePath, targetPath, fallback = '') {
  const resolvedTargetPath = resolveChildPath(sourcePath, targetPath)
  if (!resolvedTargetPath || isSameRoutePath(sourcePath, resolvedTargetPath)) return fallback
  return resolvedTargetPath
}

export function setFirstChildRedirect(route) {
  const firstChild = route.children[0]
  const firstChildPath = firstChild.path !== undefined && firstChild.path !== null ? firstChild.path : firstChild.linkPath
  const redirect = getSafeRedirect(route.path, firstChildPath)
  if (redirect) {
    route.redirect = redirect
  } else {
    // 父子路由同路径时改为默认子路由，避免 redirect 指回父路由造成无限递归
    firstChild.path = ''
    delete route.redirect
  }
  return route
}
